export default __webpack_public_path__ + "static/michelle-cc4fe1e27ff681d74251b80a1008b667.png";